import { render, staticRenderFns } from "./GetCartDosage.vue?vue&type=template&id=3aa7aec7&scoped=true"
import script from "./GetCartDosage.vue?vue&type=script&lang=js"
export * from "./GetCartDosage.vue?vue&type=script&lang=js"
import style0 from "./GetCartDosage.vue?vue&type=style&index=0&id=3aa7aec7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aa7aec7",
  null
  
)

export default component.exports